import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable, BehaviorSubject } from "rxjs";
import { CommonWebService, UserHttpService, CreateLead, HttpResponse, LeadList, LeadDetails, AddActivity, LeadAppoinment, DEVICE_CREDENTIALS, DeleteleadAppoinment, LeadCallschedule, DeleteLeadCallschedule, DeleteLeadDocument, UserHttpResponse } from "../public-api";

@Injectable({
    providedIn: 'root'
})
export class ManageLeadsService {
    public reloadLeadsList$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    constructor(
        private http: HttpClient,
        private commonService: CommonWebService,
        private userSessionService: UserHttpService
    ) { }


    public createLead(body: CreateLead, isEdit: boolean = false): Observable<HttpResponse<any>> {
        let formData = new FormData();
        let leadOwnerName = `${this.userSessionService.getUserInfo.usr_first_name ? this.userSessionService.getUserInfo.usr_first_name : ''} ${this.userSessionService.getUserInfo.usr_last_name ? this.userSessionService.getUserInfo.usr_last_name : ''}`;
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('customer_id', this.userSessionService.getUserInfo.usr_customer_track_id);
        //formData.append('leadOwnerid', this.userSessionService.getUserInfo.user_id ? this.userSessionService.getUserInfo.user_id : '');
        formData.append('leadOwner', leadOwnerName);
        formData.append('leadSource', body.leadSource ? body.leadSource : '');
        formData.append('companyName', body.companyName ? body.companyName : '');
        formData.append('firstName', body.firstName ? body.firstName : '');
        formData.append('lastName', body.lastName ? body.lastName : '');
        formData.append('leadEmail', body.leadEmail ? body.leadEmail : '');
        formData.append('leadPhone', body.leadPhone ? body.leadPhone : '');
        formData.append('leadAddress1', body.leadAddress1 ? body.leadAddress1 : '');
        formData.append('leadAddress2', body.leadAddress2 ? body.leadAddress2 : '');
        formData.append('leadCountry', body.leadCountry ? body.leadCountry : '');
        formData.append('leadState', body.leadState ? body.leadState : '');
        formData.append('leadCity', body.leadCity ? body.leadCity : '');
        formData.append('leadZip', body.leadZip ? body.leadZip : '');
        formData.append('leadStage', body.leadStage ? body.leadStage : '1');

        return this.http.post<HttpResponse<any>>('leads/addLeads', formData);
    }


    public getLeadList(
        leadSource?: string,
    ): Observable<HttpResponse<LeadList[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('customer_id', this.userSessionService.getUserInfo.usr_customer_track_id);
        if (leadSource) {
            formData.append("leadSource", leadSource ? leadSource : '');
        }

        return this.http.post<HttpResponse<LeadList[]>>('leads/addLeads/getLeadslist', formData);
    }

    public getLeadSources(): Observable<HttpResponse<LeadList[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('customer_id', this.userSessionService.getUserInfo.usr_customer_track_id);
        return this.http.post<HttpResponse<LeadList[]>>('leads/leadSource', formData);
    }

    public getLeadDetails(leadid: string): Observable<HttpResponse<LeadDetails>> {
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('leadid', leadid ? leadid : '')
        return this.http.post<HttpResponse<LeadDetails>>(`leads/AddLeads/getleadview`, formData).pipe(
            map((res: HttpResponse<any>) => {
                if (res && res.data && res.data[0]) {
                    res.data = res.data[0];
                }
                return res;
            })
        )
    }

    public deleteLead(leadid: string): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('leadid', leadid ? leadid : '');
        return this.http.post<HttpResponse<any>>(`leads/AddLeads/deleteleaddetail`, formData)
    }

    public addAcitivity(body: AddActivity, leadid: string): Observable<HttpResponse<AddActivity>> {
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('activity_type', body.activity_type);
        formData.append('activity_date', body.activity_date);
        formData.append('activity_time', body.activity_time);
        formData.append('notes', body.notes);
        formData.append('leadid', leadid ? leadid : '');
        return this.http.post<HttpResponse<AddActivity>>(`leads/AddLeads/addLeadActivty`, formData)
    }

    public leadAppoinment(body: LeadAppoinment, isEdit: boolean = false): Observable<HttpResponse<LeadAppoinment>> {
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('organiser', body.organiser);
        formData.append('leadOwner', body.leadOwner);
        formData.append('subject', body.subject);
        formData.append('meeting_date', body.meeting_date ? this.commonService.changeDateFormat(new Date(body.meeting_date) as Date) : '');
        formData.append('meeting_time', body.meeting_time);
        formData.append('reminder', body.reminder);
        formData.append('location', body.location);
        formData.append('description', body.description);
        formData.append('leadid', body.leadid ? body.leadid : '');

        if (isEdit && body.aptid) {
            formData.append('aptid', body.aptid ? body.aptid : '');
        }

        return this.http.post<HttpResponse<LeadAppoinment>>(`leads/AddLeads/lead_appoinment`, formData)
    }
    public deleteleadAppoinment(body: DeleteleadAppoinment): Observable<HttpResponse<DeleteleadAppoinment>> {
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('leadid', body.leadid ? body.leadid : '');
        formData.append('aptid', body.aptid);

        return this.http.post<HttpResponse<DeleteleadAppoinment>>(`leads/AddLeads/deletelead_appoinment`, formData)
    }

    public leadCallschedule(body: LeadCallschedule, isEdit: boolean = false): Observable<HttpResponse<LeadCallschedule>> {
        //console.log(body)
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('organiser', body.organiser);
        formData.append('leadOwner', body.leadOwner);
        formData.append('subject', body.subject);
        formData.append('lead_name', body.lead_name);
        formData.append('contact_number', body.contact_number);
        formData.append('zoom_link', body.zoom_link);
        formData.append('call_type', body.call_type);
        formData.append('reminder_days', body.reminder_days);
        formData.append('reminder_time', body.reminder_time);
        formData.append('call_date', body.call_date ? this.commonService.changeDateFormat(new Date(body.call_date) as Date) : '');
        formData.append('call_time', body.call_time);
        formData.append('call_description', body.call_description);
        formData.append('leadid', body.leadid ? body.leadid : '');
        formData.append('contact_type', body.contact_type ? body.contact_type : '');

        if (isEdit && body.callid) {
            formData.append('callid', body.callid ? body.callid : '');
        }

        return this.http.post<HttpResponse<LeadCallschedule>>(`leads/AddLeads/lead_callschedule`, formData)
    }
    public deleteLeadCallschedule(body: DeleteLeadCallschedule): Observable<HttpResponse<DeleteLeadCallschedule>> {
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('leadid', body.leadid ? body.leadid : '');
        formData.append('callid', body.callid ? body.callid : "");

        return this.http.post<HttpResponse<DeleteLeadCallschedule>>(`leads/AddLeads/deletelead_callschedule`, formData)
    }
    public leadDocument(leadid: string, img: any): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('leadid', leadid ? leadid : "");
        formData.append('file_upload', img ? img : "");

        return this.http.post<HttpResponse<any>>(`leads/AddLeads/lead_document`, formData)
    }

    public phoneCall(contact_number: string): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('leadPhone', contact_number ? contact_number : "");
        return this.http.post<HttpResponse<any>>(`leads/callCustomer`, formData)
    }
    public deleteLeadDocument(body: DeleteLeadDocument): Observable<HttpResponse<DeleteLeadDocument>> {
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('leadid', body.leadid ? body.leadid : "");
        formData.append('documentid', body.documentid ? body.documentid : "");

        return this.http.post<HttpResponse<DeleteLeadDocument>>(`leads/AddLeads/deletelead_document`, formData)
    }

    //import Leads from .CSV
    public importLeads(file: File): Observable<UserHttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('customer_id', this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('ImportLeads', file ? file : '');
        return this.http.post<UserHttpResponse<any>>('leads/importLeads', formData);
    }

    //EXPORT LEADS
    public exportLeads(): Observable<UserHttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('customer_id', this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        return this.http.post<UserHttpResponse<any>>('leads/exportLeads', formData);
    }


}